<script setup>
import AnButton from "@/components/common/AnButton.vue";
import NewsTab from "@/tabs/user-dashboard/NewsTab.vue";
import { ref } from "vue";

const props = defineProps({
  news: {
    type: Array,
    default: [],
  },
});

const newsView = ref(true);
</script>

<template>
  <div class="d-flex flex-direction-column news-wrapper br-10 mt-30 p-15">
    <div class="d-flex gap-20">
      <AnButton
        label="News"
        :variant="newsView ? 'primary' : 'tab'"
        @click="() => (newsView = true)"
      />
      <AnButton
        label="Upcoming Events"
        :variant="!newsView ? 'primary' : 'tab'"
        @click="() => (newsView = false)"
      />
    </div>
    <div class="pt-15 pr-15 flex-1 d-flex">
      <div v-if="news.length < 1">no news</div>
      <template v-else-if="newsView && news.length > 0">
        <NewsTab :news="news" />
      </template>
      <div v-else>upcoming events</div>
    </div>
  </div>
</template>

<style scoped>
.news-wrapper {
  border: 1px solid var(--an-gray1);
}
</style>
